import { view } from "@risingstack/react-easy-state";
import React from "react";
import { useBlocks } from "../../../../hooks/useBlocks";
import blocks from "../../../../store/modules/blocks";

export default view(({ button }: any) => {
  const { sections } = blocks;
  const getBlock: any = useBlocks({
    sections,
    sectionName: "gold-coins",
  });

  const block1 = getBlock("lorem-ipsum-dolor-sit-amet-c");
  const block2 = getBlock("lorem-ipsum-dolor-sit-amet-c_1");
  const block3 = getBlock("lorem-ipsum-dolor-sit-amet-c_2");
  const block4 = getBlock("ready-to-buy-more-than-50-coi");

  return (
    <>
      <div className="flex flex-row flex-wrap flex-1 mb-14">
        <div className="flex flex-auto items-center justify-center h-[400px] order-1 lg:flex-1 lg:order-2">
          <img src={block1?.imageUrl} className="max-h-full" />
        </div>

        <div className="flex flex-auto flex-col order-2 lg:flex-1">
          <h2 className="text-[1.6rem] leading-tight">{block1?.title}</h2>

          <div dangerouslySetInnerHTML={{ __html: block1?.text || "" }} />

          {button}
        </div>
      </div>

      <div className="flex flex-row flex-wrap flex-1 mb-14">
        <div className="flex flex-auto flex-col order-2 lg:flex-1">
          <h2 className="text-[1.6rem] leading-tight">{block2?.title}</h2>

          <div dangerouslySetInnerHTML={{ __html: block2?.text || "" }} />

          {button}
        </div>

        <div className="flex flex-auto items-center justify-center h-[400px] order-1 lg:flex-1 lg:order-2">
          <img src={block2?.imageUrl} className="max-h-full" />
        </div>
      </div>

      <div className="flex flex-row flex-wrap mb-14">
        <div className="flex flex-auto items-center justify-center h-[400px] order-1 lg:flex-1 lg:order-2">
          <img src={block3?.imageUrl} className="max-h-full" />
        </div>

        <div className="flex flex-auto flex-col order-2 lg:flex-1">
          <h2 className="text-[1.6rem] leading-tight">{block3?.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: block3?.text || "" }} />

          {button}
        </div>
      </div>

      <div className="flex">
        <div
          dangerouslySetInnerHTML={{ __html: block4?.text || "" }}
          className="text-[1.6rem] leading-tight text-center w-full"
        />
      </div>
    </>
  );
});
